import { useState, useCallback, useRef, useEffect } from 'react';
import { computeOutlineFeatures } from '../../static/js/OutlineUtils';

const EMPTY_FC = { type: 'FeatureCollection', features: [] };

export const useFlash = (duration = 2000) => {
    const [flashOutline, setFlashOutline] = useState(EMPTY_FC);
    const [isFlashing, setIsFlashing] = useState(false);
    const hideTimeoutRef = useRef(null);
    const clearTimeoutRef = useRef(null);

    const startFlash = useCallback((clusterFeatures) => {
        if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        if (clearTimeoutRef.current) clearTimeout(clearTimeoutRef.current);

        const arr = Array.isArray(clusterFeatures) ? clusterFeatures : [clusterFeatures];
        const outlineFeatures = computeOutlineFeatures(arr);

        setFlashOutline({ type: 'FeatureCollection', features: outlineFeatures });
        // rAF гарантирует, что source получит новую геометрию до включения opacity,
        // иначе maplibre transition может "проглотить" первый кадр
        requestAnimationFrame(() => setIsFlashing(true));

        hideTimeoutRef.current = setTimeout(() => {
            setIsFlashing(false); // запускает fade-out через line-opacity-transition
            clearTimeoutRef.current = setTimeout(() => {
                setFlashOutline(EMPTY_FC);
            }, 500); // держим геометрию, пока идёт затухание, чтобы не обрубить transition
            hideTimeoutRef.current = null;
        }, duration);
    }, [duration]);

    useEffect(() => {
        return () => {
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
            if (clearTimeoutRef.current) clearTimeout(clearTimeoutRef.current);
        };
    }, []);

    return { flashOutline, isFlashing, startFlash };
};